<template>
  <AppSection>
    <a name="form" />
    <AppContainer>
      <div class="content flex col gap-6 items-center">
        <AppHeaderWithImg 
          :text="$tt(`page.form_title_${country}`)"
          src="/images/clipboard-with-checkmarks.jpg"
          :alt="$tt('images.clipboard_checkmark')"
          row
        />
        <div class="form">
          <div class="elevated">
            <LazyIndiaVisaForm v-if="country == 'india'" :products />
            <LazyCanadaVisaForm v-else-if="country == 'canada'" :products />
            <LazySriLankaVisaForm v-else-if="country == 'sri_lanka'" :products />
            <LazyMoroccoVisaForm v-else-if="country == 'morocco'" :products />
            <LazyNewZealandVisaForm v-else-if="country == 'new_zealand'" :products />
            <LazyVietnamVisaForm v-else-if="country == 'vietnam'" :products />
            <LazyUsaVisaForm v-else-if="country == 'usa'" :products />
            <LazyKoreaVisaForm v-else-if="country == 'korea'" :products />
            <LazyCambodiaVisaForm v-else-if="country == 'cambodia'" :products />
            <LazyIsraelVisaForm v-else-if="country == 'israel'" :products />
            <LazySaudiArabiaVisaForm v-else-if="country == 'saudi_arabia'" :products />
            <LazyBahrainVisaForm v-else-if="country == 'bahrain'" :products />
            <LazyIndonesiaVisaForm v-else-if="country == 'indonesia'" :products />
            <LazyUkVisaForm v-else-if="country == 'uk'" :products />
            <LazyTogoVisaForm v-else-if="country == 'togo'" :products />
            <LazyThailandVisaForm v-else-if="country == 'thailand'" :products />
            <LazySchengenVisaForm v-else-if="country == 'schengen'" :products />
          </div>

          <DesktopOnly>
            <CountryStamp :country class="stamp" />
          </DesktopOnly>
        </div>
        <AppContainer v-if="safetyBoxVisible" :width="mobile ? 'full' : 'narrow'">
          <SafetyLightBox class="mt-4" />
        </AppContainer>
      </div>
    </AppContainer>
  </AppSection>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import type { Product } from '~/types';

const country = inject(countryKeyInjectionKey)!;
defineProps<{
  products: Product[];
}>();

const safetyBoxVisible = useFeatureFlag('safety-box');
const { mobile } = useBreakpoints();
</script>

<style scoped lang="scss">
.form {
  position: relative;
  max-width: 100%;
}
.elevated {
  position: relative;
  z-index: 5;
}
.stamp {
  max-width: unset;
  position: absolute;
  top: 60%;
  left: calc(-1 * var(--space-8)); // `inset` is buggy on RTL
  transform: translate(-50%, -50%);
  z-index: 0;
}
@media (max-width: 850px) {
  .content {
    align-items: flex-start;
  }
}
</style>